module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8zqMF"))).then(() => parcelRequire('cvs7o'));